// extracted by mini-css-extract-plugin
export default {"button":"Button_button__tkOMp","buttonIcon":"Button_buttonIcon__ioneh"};